import React, { Fragment } from "react"
import { Container, Jumbotron } from "react-bootstrap"
import { Redirect, withRouter } from "react-router-dom"
import NavBarUser from "../../components/shared/NavBarUser"
import Papeleta from "../../components/user/Papeleta"

const VotaUsuario = ({ location }) => {


	const votacion = location.votacion
	if (!votacion) {
		return <Redirect to="/votaciones" />
	} else {
		return (
			<Fragment>
				<NavBarUser />
				<Container className="mt-4">
					<Jumbotron>
						<h1>Elección: {votacion.nombre}</h1>
						<h4>Unidad: {votacion.unidad.nombre}</h4>
						<p>{votacion.descripcion}</p>
						<hr />
						<div className="text-center mb-4">
							<h2>Candidatos</h2>
							A continuación se presenta la lista de candidatos, recuerde hacer clic en la linea del/la candidato de su preferencia.
						</div>
						<Papeleta votacion={votacion} />
					</Jumbotron>
				</Container>
			</Fragment>
		)
	}
}

export default withRouter(VotaUsuario)
